import { useEffect } from 'react'
import { useDemoTour } from './useDemoTour'
import { demoTourCSS } from './demoTourStyles'

interface DemoTourProps {
  variant: 'admin' | 'customer'
  enabled: boolean
}

export default function DemoTour({ variant, enabled }: DemoTourProps) {
  const { startTour } = useDemoTour(variant, enabled)

  // Inject dark-theme CSS overrides
  useEffect(() => {
    if (!enabled) return

    const style = document.createElement('style')
    style.setAttribute('data-demo-tour', variant)
    style.textContent = demoTourCSS
    document.head.appendChild(style)

    return () => {
      style.remove()
    }
  }, [enabled, variant])

  // Listen for CustomEvent to replay tour
  useEffect(() => {
    if (!enabled) return

    const handler = () => startTour()
    window.addEventListener('startDemoTour', handler)

    return () => {
      window.removeEventListener('startDemoTour', handler)
    }
  }, [enabled, startTour])

  return null
}
